<template>
  <div class="mb-4 flex flex-col items-start" @mouseleave="current = null">
    <div>
      <div class="mb-2 inline-flex font-bold gap-4">
        <div v-for="i in count" :key="i" @click="model = i">
          <div
            v-if="context.as_numbers"
            :class="i <= current || i <= model ? 'bg-primary text-white' : ''"
            class="flex h-12 w-12 cursor-pointer items-center justify-center rounded-md font-bold ring-1 ring-primary hover:bg-primary hover:text-white transition-colors"
          >
            <span v-text="i" />
          </div>
          <div
            v-else
            class="group/item flex flex-col items-center"
            @mouseenter="current = i"
          >
            <component
              class="h-6 w-6 mb-1 cursor-pointer text-primary transition-colors"
              :class="i <= current || i <= model ? 'fill-primary' : ''"
              :is="iconSet"
            />
            <span class="text-nandor-600 text-lg" v-text="i" />
          </div>
        </div>
      </div>
      <div class="flex items-center justify-between gap-4 mt-1">
        <span
          v-if="!context.hide_labels"
          v-text="context.low_label"
          class="w-full appearance-none bg-transparent text-left outline-none transition-colors text-gunsmoke-400 h-[22px]"
        />
        <span
          v-if="!context.hide_labels"
          v-text="context.high_label"
          class="w-full appearance-none bg-transparent text-right outline-none transition-colors text-gunsmoke-400 h-[22px]"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted, ref } from 'vue'

import { IconHeart, IconStar } from '@tabler/icons-vue'

const props = defineProps({
  context: {
    type: Object,
    default: {},
  },
  modelValue: {
    type: [String, Number],
  },
  passed: {
    type: Boolean,
  },
  current: {
    type: Boolean,
  },
})

const current = ref(null)

const icons = ref({
  stars: IconStar,
  hearts: IconHeart,
})

const iconSet = computed(() => {
  return icons.value[props.context.icons]
})

const count = computed(() => {
  return props.context?.count && props.context.count < 10
    ? parseInt(props.context?.count)
    : 10
})

const emits = defineEmits(['passed', 'update:model-value'])

const model = computed({
  get: () => {
    return props.modelValue ?? []
  },
  set: (val) => {
    emits('update:model-value', val)
  },
})

onMounted(() => {
  document.addEventListener('keypress', function (event) {
    if (props.current && !props.passed) {
      const v = parseInt(event.key)
      if (v && v <= count.value.length) {
        model.value = count.value[v - 1]
      }
    }
  })
})
</script>
